export class WebSocketCommunityEventName {

    public static COMMUNITY_ONBOARDING_JOIN = "community/onboarding/join";
    public static COMMUNITY_ONBOARDING_LEAVE = "community/onboarding/leave";
    public static COMMUNITY_ONBOARDING_UPDATE2 = "community/onboarding/update2";

    public static COMMUNITY_JOIN = "community/join";
    public static COMMUNITY_LEAVE = "community/leave";
    public static COMMUNITY_UPDATE = "community/update";
    public static COMMUNITY_UPDATE_ONBOARD = "community/update/onboard";
    public static COMMUNITY_WRITING_STYLE_UPDATE = "community/writingStyle/update";
    public static COMMUNITY_DOCUMENT_UPDATE = "community/document/update";
    public static COMMUNITY_DOCUMENT_DELETE = "community/document/delete";
    public static COMMUNITY_BRAND_FACTS_UPDATE = "community/brand/facts/update";
    public static COMMUNITY_SEO_CLUSTER_KEYWORDS_CREATE = "community/seo/cluster/keywords/create";
    public static COMMUNITY_SEO_AUDIT_UPDATE = "community/seo/audit/update";
    public static COMMUNITY_SEO_PAGE_TRACKING_UPDATE = "community/seo/pageTracking/update";
    public static COMMUNITY_SEO_PAGE_TRACKING_DELETE = "community/seo/pageTracking/delete";
    public static COMMUNITY_SEO_BACKLINK_UPDATE = "community/seo/backlink/update";
    public static COMMUNITY_SEO_BACKLINK_EVALUATION_UPDATE = "community/seo/backlink/evaluation/update";
    public static COMMUNITY_SEO_COMPETITORS_UPDATE = "community/seo/competitors/update";
    public static COMMUNITY_SEO_COMPETITOR_POSITIONS_UPDATE = "community/seo/competitor/positions/update";
    public static COMMUNITY_SEO_COMPETITOR_ENRICHMENT_UPDATE = "community/seo/competitor/enrichment/update";
    public static COMMUNITY_SEO_BACKLINK_CAMPAIGN_UPDATE = "community/seo/backlink/campaign/update";
    public static COMMUNITY_INDEXATION_CHANGED = "community/indexation/changed";
    public static COMMUNITY_LLM_RESPONSE_UPDATE = "community/llm/response/update";

    public static COMMUNITY_ARTICLE_JOIN = "community/article/join";
    public static COMMUNITY_ARTICLE_LEAVE = "community/article/leave";

    public static COMMUNITY_ARTICLE_CREATE = "community/article/create";
    public static COMMUNITY_ARTICLE_DELETE = "community/article/delete";
    public static COMMUNITY_ARTICLE_UPDATE = "community/article/update";
    public static COMMUNITY_ARTICLE_RATING_UPDATE = "community/article/rating/update";
    public static COMMUNITY_ARTICLE_COMMENT_UPDATE = "community/article/comment/update";
    public static COMMUNITY_ARTICLE_OPTIMIZATION_BATCH_UPDATE = "community/article/optimizationBatch/update";
    public static COMMUNITY_CTA_GENERATED = "community/cta/generated";
    public static COMMUNITY_ARTICLE_PROPOSAL_CREATE = "community/article/proposal/create";
    public static COMMUNITY_ARTICLE_SECTION_CREATE = "community/article/section/create";

    public static COMMUNITY_IMAGES_UPDATE = "community/images/update";

    public static COMMUNITY_ALT_IMAGE_UPDATE = "community/alt/image/update";
    public static COMMUNITY_ALT_OVERVIEW_UPDATE = "community/alt/overview/update";
    public static COMMUNITY_ALT_SCAN_END = "community/alt/scan/end";

    public static COMMUNITY_LIBRARY_MEDIA_UPDATE = "community/library/media/update";
    public static COMMUNITY_LIBRARY_IMPORT_END = "community/library/import/end";

    public static COMMUNITY_AGENT_REPORT_UPDATE = "community/agent/report/update";

    public static COMMUNITY_AUTOPILOT_UPDATE = "community/autopilot/update";

    public static COMMUNITY_CALENDAR_UPDATE = "community/calendar/update";

    public static COMMUNITY_AGENT_CHAT_ACK = "community/agent/chat/ack";
    public static COMMUNITY_AGENT_CHAT_STREAM = "community/agent/chat/stream";
    public static COMMUNITY_AGENT_CHAT_TOOL_START = "community/agent/chat/tool/start";
    public static COMMUNITY_AGENT_CHAT_TOOL_END = "community/agent/chat/tool/end";
    public static COMMUNITY_AGENT_CHAT_READING = "community/agent/chat/reading";
    public static COMMUNITY_AGENT_CHAT_END = "community/agent/chat/end";
    public static COMMUNITY_AGENT_CHAT_ERROR = "community/agent/chat/error";
    public static COMMUNITY_AGENT_CHAT_WIDGET = "community/agent/chat/widget";
    public static COMMUNITY_AGENT_CHAT_NOTIFICATION = "community/agent/chat/notification";
    public static COMMUNITY_AGENT_CHAT_TYPING = "community/agent/chat/typing";
    public static COMMUNITY_AGENT_CHAT_UPDATED = "community/agent/chat/updated";

    public static COMMUNITY_ARTICLE_AI_CHAT_ACK = "community/article/ai/chat/ack";
    public static COMMUNITY_ARTICLE_AI_CHAT_STEP = "community/article/ai/chat/step";
    public static COMMUNITY_ARTICLE_AI_CHAT_EDITS = "community/article/ai/chat/edits";
    public static COMMUNITY_ARTICLE_AI_CHAT_END = "community/article/ai/chat/end";
    public static COMMUNITY_ARTICLE_AI_CHAT_ERROR = "community/article/ai/chat/error";

}